import { render, staticRenderFns } from "./CsgPurchaseViewForm.vue?vue&type=template&id=0e2a2ed4&scoped=true"
import script from "./CsgPurchaseViewForm.vue?vue&type=script&lang=js"
export * from "./CsgPurchaseViewForm.vue?vue&type=script&lang=js"
import style0 from "./CsgPurchaseViewForm.vue?vue&type=style&index=0&id=0e2a2ed4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a2ed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2a2ed4')) {
      api.createRecord('0e2a2ed4', component.options)
    } else {
      api.reload('0e2a2ed4', component.options)
    }
    module.hot.accept("./CsgPurchaseViewForm.vue?vue&type=template&id=0e2a2ed4&scoped=true", function () {
      api.rerender('0e2a2ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/components/CsgPurchaseViewForm.vue"
export default component.exports